import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export const BANNERS = {
  general: { id: "general", src: "/banners/general", to: "/shop", alt: "Wear what feels like you — GirlyGrove" },
  "it-girl": { id: "it-girl", src: "/banners/itgirl", to: "/bundle/it-girl", alt: "The It-Girl Box — pick any 3 for ₹499" },
  glam: { id: "glam", src: "/banners/glam", to: "/bundle/glam", alt: "Glam Box — pick any 5 at ₹799" },
  dream: { id: "dream", src: "/banners/dream", to: "/bundle/dream", alt: "The Dream Box — pick any 7 for ₹1,199" },
};

// Full image always visible (natural 2.5:1 aspect) — no side cropping on any screen
export const HeroBannerSlider = ({ slides, interval = 2000, linkable = true, testId = "hero-banner-slider" }) => {
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);
  const touchX = useRef(null);
  const { pathname } = useLocation();

  // Same-page banner → glide down to the products
  const onSlideClick = (e, s) => {
    if (s.to !== pathname) return;
    e.preventDefault();
    document.getElementById("bundle-products")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const n = slides.length;

  useEffect(() => {
    if (n < 2 || paused) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % n), interval);
    return () => clearInterval(t);
  }, [n, interval, paused]);

  const go = (d) => setIdx((i) => (i + d + n) % n);

  return (
    <div className="w-full bg-cream">
    <section
      className="relative w-full mx-auto overflow-hidden bg-[#F3E6DA] lg:max-w-[calc((100vh-132px)*2.5)]"
      style={{ aspectRatio: "1983 / 793" }}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onTouchStart={(e) => (touchX.current = e.touches[0].clientX)}
      onTouchEnd={(e) => {
        if (touchX.current == null) return;
        const dx = e.changedTouches[0].clientX - touchX.current;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
        touchX.current = null;
      }}
      data-testid={testId}
    >
      {slides.map((s, i) => {
        const img = (
          <picture>
            <source media="(max-width: 767px)" srcSet={`${s.src}-m.webp`} />
            <img
              src={`${s.src}.webp`}
              alt={s.alt}
              className="absolute inset-0 w-full h-full object-contain"
              loading={i === 0 ? "eager" : "lazy"}
              draggable="false"
            />
          </picture>
        );
        const cls = `absolute inset-0 transition-opacity duration-700 ease-out ${i === idx ? "opacity-100 z-10" : "opacity-0 z-0 pointer-events-none"}`;
        return linkable ? (
          <Link key={s.id} to={s.to} onClick={(e) => onSlideClick(e, s)} className={cls} aria-hidden={i !== idx} data-testid={`${testId}-slide-${s.id}`}>
            {img}
          </Link>
        ) : (
          <div key={s.id} className={cls} aria-hidden={i !== idx} data-testid={`${testId}-slide-${s.id}`}>
            {img}
          </div>
        );
      })}

      {n > 1 && (
        <div className="absolute bottom-1.5 right-2 sm:bottom-3 sm:right-4 z-20 flex items-center gap-1.5 px-2 py-1 rounded-full bg-white/35 backdrop-blur-md">
          {slides.map((s, i) => (
            <button
              key={s.id}
              onClick={() => setIdx(i)}
              aria-label={`Show ${s.alt}`}
              className={`h-1.5 rounded-full transition-[width,background-color] duration-300 ${i === idx ? "w-5 bg-plum" : "w-1.5 bg-plum/35"}`}
              data-testid={`${testId}-dot-${i}`}
            />
          ))}
        </div>
      )}
    </section>
    </div>
  );
};

export default HeroBannerSlider;
